import {Usuari} from "../model/Usuari";

const apiUrl = process.env.REACT_APP_API_URL;
export const PutUsuariIdActivitatId = async (usuari: string, problema: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/bbdd/users/${usuari}/exercici/${problema}/reclamar`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (!response.ok) {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
